// Lightweight cache of "which sessions have recordings on the server".
// Used by the monitor to surface a small reel indicator, and by the
// Conversation page to decide whether to render the Recordings panel.
//
// Single source of truth = the server. Refreshed via `refreshRecordings()`
// at boot and after `playback` / `delete` actions.

import { create } from 'zustand';
import type { SessionId } from '@prakash-software/shared';

interface RecordingsState {
  sessionIds: Set<SessionId>;
  setAll: (ids: SessionId[]) => void;
  add: (id: SessionId) => void;
  remove: (id: SessionId) => void;
}

export const useRecordingsStore = create<RecordingsState>((set) => ({
  sessionIds: new Set(),
  setAll: (ids) => set({ sessionIds: new Set(ids) }),
  add: (id) =>
    set((s) => {
      if (s.sessionIds.has(id)) return s;
      const next = new Set(s.sessionIds);
      next.add(id);
      return { sessionIds: next };
    }),
  remove: (id) =>
    set((s) => {
      if (!s.sessionIds.has(id)) return s;
      const next = new Set(s.sessionIds);
      next.delete(id);
      return { sessionIds: next };
    }),
}));
